(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teflo-faq"] && !Shopify.designMode) return;
  try {
    
  //点击展开，收起，切换svg，动画用gsap
  document.querySelectorAll('.teflo-faq-list-rt-item-top').forEach((item, index) => {
    item.addEventListener('click', () => {
      let content = item.nextElementSibling;
      let svg = item.querySelector('.teflo-faq-list-rt-item-top-svg');
      let svg1 = svg.querySelector('.teflo-faq-list-rt-item-top-svg1');
      let svg2 = svg.querySelector('.teflo-faq-list-rt-item-top-svg2');
      if (content.style.height == '0px' || content.style.height == '') {
        content.style.height = content.scrollHeight + 'px';

        svg1.style.display = 'none';
        svg2.style.display = 'block';
      } else {
        svg1.style.display = 'block';
        svg2.style.display = 'none';
        content.style.height = '0px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teflo-form"] && !Shopify.designMode) return;
  try {
    
  var tefloFormSelectInput = document.querySelectorAll('.teflo-form-select .teflo-form-select-input');
  tefloFormSelectInput.forEach(function (item) {
    item.addEventListener('click', function () {
      var optionbox = item.nextElementSibling;
      if (optionbox.style.height == '0px' || optionbox.style.height == '') {
        gsap.to(optionbox, { height: 'auto', duration: 0.3, ease: 'power4.out' });
      } else {
        gsap.to(optionbox, { height: '0px', duration: 0.3, ease: 'power4.out' });
      }
    });
  });
  let tefloFormSelectOption = document.querySelectorAll('.teflo-form-select-option');
  tefloFormSelectOption.forEach(function (item) {
    item.addEventListener('click', function () {
      var hiddenInput = document.querySelector('.' + item.getAttribute('data-value-hidden-input'));
      var valuePlaceholder = document.querySelector('.' + item.getAttribute('data-value-placeholder'));
      hiddenInput.value = item.getAttribute('data-value');
      hiddenInput.dispatchEvent(new Event('change'));
      valuePlaceholder.innerHTML = item.innerHTML;
      valuePlaceholder.style.opacity = 1;
      var parentEle = document.querySelector('.' + item.getAttribute('data-parent-ele'));
      gsap.to(parentEle, { height: '0px', duration: 0.3, ease: 'power4.out' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
